var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sign-main" }, [
    _c("div", { staticClass: "sign_box" }, [
      _c("div", { staticClass: "box_left", class: { active: _vm.open } }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/logo/logo.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("Production Portal")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box_left_b" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("mmLogin", { ref: "mmLogin", on: { success: _vm.getRoles } }),
            _vm._v(" "),
            _c("div", { staticClass: "foot_tip" }, [
              _vm._v(
                "\n          After logging in with an unregistered account, it will be automatically\n          registered.\n        "
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.open
        ? _c("div", { staticClass: "box_right fr" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/logo/logo.png") },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v("Production Portal")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box_list" },
              [
                _c("div", { staticClass: "tip" }, [
                  _vm._v("Please select a role:"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.roleList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.type,
                      staticClass: "listItem",
                      on: {
                        click: function ($event) {
                          return _vm.getSignture(item)
                        },
                      },
                    },
                    [
                      item.type == 0
                        ? _c("span", [_vm._v("Producer")])
                        : _vm._e(),
                      _vm._v(" "),
                      item.type == 1
                        ? _c("span", [_vm._v("FoundationManager")])
                        : _vm._e(),
                      _vm._v(" "),
                      item.type == 3
                        ? _c("span", [_vm._v("Beneficiary")])
                        : _vm._e(),
                      _vm._v(" "),
                      item.producerAddress
                        ? _c("account", {
                            staticStyle: { color: "#999" },
                            attrs: { value: item.producerAddress },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.handleBack },
                      },
                      [
                        _c("img", {
                          staticClass: "icon_back",
                          attrs: {
                            src: require("@/assets/image/login/back.png"),
                          },
                        }),
                        _vm._v("\n            Reselect wallet\n          "),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn_tip" }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("Please connect wallet:\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }